import { type ReactElement } from 'react'
import { Text } from '@mantine/core'
import { type TeamNodeContentProps } from './types'

export const BasicNode = ({ team }: TeamNodeContentProps): ReactElement => {
  return <Text className='text-center'>{team.name}</Text>
}
